module.exports = __webpack_public_path__ + "static/media/pulverizador_03.537bb140.png";